import React, { Component } from "react";
import postscribe from "postscribe";
import "./Futures.css";
import Config from "../../../config/config";

class GrainsOilSeeds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingError: false,
      loading: true,
      loadedScripts: 0,
      totalScripts: 9,
    };
  }

  componentDidMount() {
    const scriptCallback = () => {
      this.setState((prevState) => {
        const newLoadedScripts = prevState.loadedScripts + 1;
        const isLoading = newLoadedScripts < prevState.totalScripts;

        // Notify parent when all scripts are loaded
        if (!isLoading && this.props.onLoadComplete) {
          this.props.onLoadComplete("grainsOilSeeds");
        }

        return {
          loadedScripts: newLoadedScripts,
          loading: isLoading,
        };
      });
    };

    postscribe(
      "#corn",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Corn:ZC,ZC*1,ZC*2,ZC*3,ZC*4,ZC*5,ZC*6,ZC*7,ZC*8,ZC*9,ZC*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#soybeans",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Soybeans:ZS,ZS*1,ZS*2,ZS*3,ZS*4,ZS*5,ZS*6,ZS*7,ZS*8,ZS*9,ZS*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#wheat",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Wheat:ZW,ZW*1,ZW*2,ZW*3,ZW*4,ZW*5,ZW*6,ZW*7,ZW*8,ZW*9,ZW*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#soybeanMeal",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Soybean Meal:ZM,ZM*1,ZM*2,ZM*3,ZM*4,ZM*5,ZM*6,ZM*7,ZM*8,ZM*9,ZM*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#soybeanOil",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Soybean Oil:ZL,ZL*1,ZL*2,ZL*3,ZL*4,ZL*5,ZL*6,ZL*7,ZL*8,ZL*9,ZL*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#kcWheat",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*K.C. Wheat:KE,KE*1,KE*2,KE*3,KE*4,KE*5,KE*6,KE*7,KE*8,KE*9,KE*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#minnWheat",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Minn. Wheat:MWE,MWE*1,MWE*2,MWE*3,MWE*4,MWE*5,MWE*6,MWE*7,MWE*8,MWE*9,MWE*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#oats",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Oats:ZO,ZO*1,ZO*2,ZO*3,ZO*4,ZO*5,ZO*6,ZO*7,ZO*8,ZO*9,ZO*10,&link=/markets/?"></script>',
      { done: scriptCallback }
    );
    postscribe(
      "#canola",
      '<script src="https://fj.qtmarketcenter.com/js/snapshot.php?symbol=*Canola:RS,RS*1,RS*2,RS*3,RS*4,RS*5,RS*6,RS*7,RS*8,RS*9,RS*10&link=/markets/?"></script>',
      { done: scriptCallback }
    );
  }

  render() {
    const { loading } = this.state;

    // Define all futures items
    const futuresItems = [
      {
        id: "corn",
        name: "Corn",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="corn"
            key="corn"
          ></div>
        ),
      },
      {
        id: "soybeans",
        name: "Soybeans",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="soybeans"
            key="soybeans"
          ></div>
        ),
      },
      {
        id: "wheat",
        name: "Chicago Wheat",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="wheat"
            key="wheat"
          ></div>
        ),
      },
      {
        id: "kcWheat",
        name: "Kansas Wheat",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="kcWheat"
            key="kcWheat"
          ></div>
        ),
      },
      {
        id: "minnWheat",
        name: "Minneapolis Wheat",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="minnWheat"
            key="minnWheat"
          ></div>
        ),
      },
      {
        id: "soybeanMeal",
        name: "Soybean Meal",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="soybeanMeal"
            key="soybeanMeal"
          ></div>
        ),
      },
      {
        id: "soybeanOil",
        name: "Soybean Oil",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="soybeanOil"
            key="soybeanOil"
          ></div>
        ),
      },
      {
        id: "oats",
        name: "Oats",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="oats"
            key="oats"
          ></div>
        ),
      },
      {
        id: "canola",
        name: "Canola",
        element: (
          <div
            className="w-full max-w-[400px] shadow-md rounded-xl"
            style={{ backgroundColor: Config.styles.surface }}
            id="canola"
            key="canola"
          ></div>
        ),
      },
    ];

    const defaultOrder = futuresItems.map((item) => item.id);

    const customOrder = Config.grainsOilseedsOrder || defaultOrder;

    const orderedItems = customOrder
      .map((id) => futuresItems.find((item) => item.id === id))
      .filter(Boolean); // Filter out any undefined items

    // If there are any items that were not in the custom order, add them at the end
    const remainingItems = futuresItems.filter(
      (item) => !customOrder.includes(item.id)
    );

    // Combine ordered items with any remaining items
    const displayItems = [...orderedItems, ...remainingItems];

    return (
      <div
        className={`grid grid-cols-1 tablet:grid-cols-2 md:grid-cols-3 justify-items-center gap-y-6 tablet:gap-y-8 gap-x-2 tablet:gap-x-5 p-4 mt-6 tablet:p-6 max-w-[1400px] mx-auto ${
          loading ? "opacity-70" : ""
        }`}
      >
        {displayItems.map((item) => item.element)}
      </div>
    );
  }
}

export default GrainsOilSeeds;
